import { render, staticRenderFns } from "./AttachmentUpload.vue?vue&type=template&id=031a7dd0&scoped=true"
import script from "./AttachmentUpload.vue?vue&type=script&lang=js"
export * from "./AttachmentUpload.vue?vue&type=script&lang=js"
import style0 from "./AttachmentUpload.vue?vue&type=style&index=0&id=031a7dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a7dd0",
  null
  
)

export default component.exports